module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_shinjuku@3x-1d125edad9b7026d3dc02805f9cb1c48.webp";